import { IEnvironmentConfiguration } from './environment';

export const environmentConfiguration: IEnvironmentConfiguration = {
	apiBasePath: 'https://pilotpay-dev-api.activeaero.com',
	isProduction: false,
	appInsightsKey: '36eadd41-1912-4fe8-948b-c61ab2132dbd',
	frontendIdentityUrl: 'https://identity-service-ui-dev.peakplatform.io',
	backendIdentityUrl: 'https://identity-service-api-dev.peakplatform.io',
	allowedEmailDomains: ['ascentgl.net']
};
